import { render } from "./Accounting.vue?vue&type=template&id=348d1813&scoped=true"
import script from "./Accounting.vue?vue&type=script&lang=js"
export * from "./Accounting.vue?vue&type=script&lang=js"

import "./Accounting.vue?vue&type=style&index=0&id=348d1813&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-348d1813"

export default script